const includedItems = [
  'İşinize özel karşılama otomasyonu',
  'WhatsApp, Instagram ve Facebook yönlendirme yapısı',
  'Reklam metinleri ve görsel içerik çalışmaları',
  'Davranış analizi sistemi',
  'Müşteri takip paneli',
  'Reklam kontrol paneli',
  'Yorum ve mesaj dönüş sistemi',
  'Gerekirse özel landing page',
  'Gerekirse işe özel ek panel veya yazılım altyapısı',
];

interface PricingSectionProps {
  onOpenApprovalModal: () => void;
}

export default function PricingSection({ onOpenApprovalModal }: PricingSectionProps) {
  return (
    <section className="py-16 md:py-24 bg-background-50" id="fiyat">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start mb-16">
          <div className="rounded-2xl bg-primary-500 p-8 md:p-10 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-accent-500/15 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-accent-500/10 rounded-full translate-y-1/2 -translate-x-1/2 blur-2xl"></div>
            <div className="relative z-10">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-4">
                İlk Ay
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-2">
                Başlangıç Bedeli
              </h2>
              <div className="text-5xl md:text-6xl font-heading font-extrabold text-accent-400 mb-4">
                5.000 TL
              </div>
              <p className="text-background-50/80 text-sm leading-relaxed mb-6">
                Ücretsiz örnek sistemi test ettikten sonra "evet, bu sistem benim işime uygundur" derseniz, ilk ay sadece 5.000 TL başlangıç bedeliyle süreç başlar.
              </p>
              <ul className="space-y-2.5">
                {includedItems.map((item) => (
                  <li key={item} className="flex items-start gap-2.5">
                    <i className="ri-check-line text-accent-400 text-sm mt-0.5 flex-shrink-0"></i>
                    <span className="text-background-50/85 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="flex flex-col justify-center">
            <p className="text-foreground-600 text-sm leading-relaxed mb-4">
              İlk ay ayrıca reklam hizmet ücreti alınmaz. 5.000 TL'lik başlangıç bedeli, sistemin server tarafında çalışması, API kodlarının işlenmesi, teknik araçların kurulması ve yapının firmanıza özel aktif hale getirilmesi için alınır.
            </p>
            <div className="rounded-xl bg-accent-100/60 border border-accent-200/50 p-5 mb-6">
              <p className="text-foreground-800 text-sm font-medium">
                İlk ay asıl hedefimiz size sistemi göstermek, işinizde çalışabilecek bir yapı kurmak ve memnun kalırsanız uzun vadeli devam etmektir.
              </p>
            </div>
            <button
              type="button"
              onClick={onOpenApprovalModal}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap w-fit"
            >
              <i className="ri-whatsapp-line"></i>
              Uygundur Yaz
            </button>
          </div>
        </div>

        <div className="max-w-3xl mx-auto text-center border-t border-background-200/70 pt-12">
          <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            Memnun Kalırsanız İkinci Aydan İtibaren 10.000 TL
          </h3>
          <p className="text-foreground-600 text-sm leading-relaxed mb-3">
            İlk ay sonunda sistemden memnun kalırsanız, ikinci aydan itibaren aylık hizmet bedeli 10.000 TL olarak devam eder.
          </p>
          <p className="text-foreground-500 text-sm mb-6">
            Memnun kalmazsanız herhangi bir taahhüt, zorunluluk veya devam baskısı yoktur. İstediğiniz zaman bırakabilirsiniz.
          </p>
          <div className="rounded-xl bg-background-100 border border-background-200/50 p-5 inline-block text-left">
            <div className="flex items-start gap-2.5">
              <i className="ri-information-line text-accent-600 text-lg flex-shrink-0 mt-0.5"></i>
              <p className="text-foreground-700 text-sm leading-relaxed">
                <strong className="text-foreground-800">Reklam bütçesi firmaya aittir.</strong> Günlük veya aylık reklam bütçesi; sektörünüze, hedefinize, kapasitenize ve kampanya yapınıza göre birlikte değerlendirilir. Harcamayı kendi reklam panelinizden kontrol edersiniz.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}